import { z } from 'zod';
import {
  PAGINATION_PAGE_SIZE_DEFAULT,
  PAGINATION_SORT_DIRECTION,
} from '~/constants';

import {
  DELIVERY_NOTE_FILTER_COMPARISON_OPERATOR,
  DELIVERY_NOTE_FILTER_NAME,
  DELIVERY_NOTE_ORDER_BY,
} from './constants';

export const zodDeliveryNotesFilterAggregatorSchema = z
  .preprocess(
    (value) =>
      value === null || value === undefined
        ? value
        : String(value).toLowerCase(),
    z.enum(['and', 'or']),
  )
  .prefault('and');

export const zodDeliveryNotesFilterClauseSchema = z.object({
  caseSensitive: z.boolean().optional().prefault(false),
  comp: z.enum(DELIVERY_NOTE_FILTER_COMPARISON_OPERATOR),
  customFieldId: z.uuid().optional(),
  name: z.enum(DELIVERY_NOTE_FILTER_NAME),
  value: z.union([
    z.string(),
    z.literal(''),
    z.number(),
    z.boolean(),
    z.array(z.any()),
    z.record(z.string(), z.any()),
  ]),
});

export const zodDeliveryNotesFilterGroupSchema = z.object({
  filterAggr: zodDeliveryNotesFilterAggregatorSchema,
  filterClauses: z.array(zodDeliveryNotesFilterClauseSchema),
});

export const zodDeliveryNotesAdminQueryParametersSchema = z.object({
  filterConfig: z
    .object({
      filterAggr: zodDeliveryNotesFilterAggregatorSchema,
      filterGroups: z.array(zodDeliveryNotesFilterGroupSchema),
    })
    .prefault({
      filterAggr: 'and',
      filterGroups: [
        {
          filterAggr: 'and',
          filterClauses: [],
        },
      ],
    }),
  includeChains: z.boolean().optional().prefault(false),
  limit: z.number().gte(1).optional().prefault(PAGINATION_PAGE_SIZE_DEFAULT),
  modifiedAfter: z.string().optional().prefault('0'),
  offset: z.number().nonnegative().optional().prefault(0),
  orderBy: z.enum(DELIVERY_NOTE_ORDER_BY).optional().prefault('dln_date'),
  sortOrder: z
    .preprocess(
      (value) =>
        value === null || value === undefined
          ? value
          : String(value).toUpperCase(),
      z.enum(PAGINATION_SORT_DIRECTION),
    )
    .optional()
    .prefault('DESC'),
});
